import { createAndroidMenu } from '../menu'

const {
  Root,
  Trigger,
  Content,
  Item,
  ItemTitle,
  ItemSubtitle,
  SubTrigger,
  Group,
  Separator,
  ItemIcon,
  ItemImage,
  CheckboxItem,
  ItemIndicator,
  Label,
  Preview,
  Arrow,
  Sub,
  SubContent,
  Auxiliary,
} = createAndroidMenu('ContextMenu')

export {
  Root,
  Trigger,
  Content,
  Item,
  ItemTitle,
  ItemSubtitle,
  SubTrigger,
  Group,
  Separator,
  ItemIcon,
  ItemImage,
  CheckboxItem,
  ItemIndicator,
  Label,
  Preview,
  Arrow,
  Sub,
  SubContent,
  Auxiliary,
}
